import { render, staticRenderFns } from "./CategoryFilterOption.vue?vue&type=template&id=3141f678&scoped=true&"
import script from "./CategoryFilterOption.vue?vue&type=script&lang=js&"
export * from "./CategoryFilterOption.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilterOption.vue?vue&type=style&index=0&id=3141f678&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3141f678",
  null
  
)

export default component.exports